import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgPathComponent } from './svgpath.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SvgPathComponent],
  exports: [SvgPathComponent]
})
export class SvgPathModule { }
